import React, { useState } from 'react';
import { channels } from './data/channels';
import TVPlayer from './components/TVPlayer';
import ChannelList from './components/ChannelList';
import CategoryFilter from './components/CategoryFilter';

const App = () => {
  const [currentChannel, setCurrentChannel] = useState(channels[7].url);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const handleChannelSelect = (url) => {
    setCurrentChannel(url);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const categories = ["All", ...new Set(channels.map((channel) => channel.category))];

  const filteredChannels = channels.filter((channel) => {
    const matchesCategory =
      selectedCategory === "All" || channel.category === selectedCategory;
    const matchesSearch = channel.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-950 to-gray-950 text-white">
      {/* Header */}
      <header className="bg-gray-900 shadow-lg py-4 text-center">
        <h1 className="text-orange-400 text-2xl font-bold">BingeHQ</h1>
        {/* <p className="text-gray-400 mt-2">Watch your favorite channels live, anytime.</p> */}
      </header>

      {/* Main Content */}
      <main className="container mx-auto p-4 items-center p-6">
        {/* TV Player */}
        <div className="container mx-auto p-4 mb-8 w-full max-w-5xl">
          {currentChannel?<TVPlayer url={currentChannel} />:""}
        </div>

            {/* Search Bar */}
            <div className="flex justify-center mb-6 space-x-4 mt-4">
          <input
            type="text"
            placeholder="Search channels..."
            value={searchQuery}
            onChange={handleSearchChange}
               className="bg-gray-900 text-white w-96 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

{/* Category Filter */}
<CategoryFilter
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={handleCategorySelect}
        />

        {/* Channel List */}
       {/* Channel List */}
       <ChannelList channels={filteredChannels} onSelectChannel={handleChannelSelect} />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 py-4 text-center">
        <p className="text-sm text-gray-400">BingeHQ</p>
      </footer>
    </div>
  );
};

export default App;
